<template lang='pug'>
  r-form(
    ref='form'
    reset-text='restablecer'
    submit-text='guardar descuento y condicion de pago'
    v-bind='formProps'
    v-model='slCustomer'
    @reset='toRefresh'
    @submit='submitUpdate'
  )
    template( slot='branch-offices-to-credit-actions' slot-scope='props' )
      v-btn-action( color='success' tooltip='Guardar' @click='submitUpdateCredit(props)' )
        v-icon save
    template( slot='footer-actions' slot-scope='props' )
      //v-btn.ml-3( 
        block
        color='secondary' 
        :disabled='props.wait'
        @click='submitCredit' 
        ) guardar cupo
      v-btn.ml-3( 
        block 
        :color="slCustomer.flag_send_debt_email ? 'error' : 'success'" 
        :disabled='props.wait'
        @click='submitEmail'
      ) {{ slCustomer.flag_send_debt_email ? 'desactivar' : 'activar' }} cobranza 
      v-btn.ml-3( 
        block 
        :color="slCustomer.blocked_sales ? 'success' : 'error'" 
        :disabled='props.wait'
        @click='submitBlock' 
        ) {{ slCustomer.blocked_sales ? 'desbloquear' : 'bloquear' }}
</template>

<script>
  //
  import { VBtnAction, RForm } from '@/components/reusable_components/next'
  //
  import SlCustomerBranchOfficesModel from '@/models/Sale/SlCustomerBranchOffices'
  import SlCustomerFields from '@/views/Sale/SlCustomer/SlCustomerFields'
  import SlCustomerModel from '@/models/Sale/SlCustomer'
  import SlCustomerService from '@/services/api/Sale/SlCustomer'
  //
  export default {
    components: {
      VBtnAction,
      RForm,
    },
    computed: {
      formProps() {
        return {
          fields: SlCustomerFields
            .include([
              'title_discount',
              'discount',
              'blocked_sales_str',
              'pch_payment_condition_id',
              'title_credit',
              //'max_customer_credit_amount',
              'flag_send_debt_email_str',
              'branch_offices_to_credit',
            ]),
        }
      },
    },
    data() {
      return {
        slCustomer: null,
        selected: null,
      }
    },
    methods: {
      getSlCustomer() {
        return SlCustomerModel
          .append('discount', 'branch_offices')
          .include('g_core_business_sii')
          .find(this.$route.params.id)
      },
      setSlCustomer(slCustomer) {
        this.slCustomer = slCustomer.reset()
      },
      showBlockError() {
        this.showErrorSnackbar('Error al modificar estado del cliente.')
      },
      showBlockSuccess() {
        this.showSuccessSnackbar('Estado del cliente modificado exitosamente.')
      },
      /*showCreditError() {
        this.showErrorSnackbar('Error al modificar el cupo del cliente.')
      },
      showCreditSuccess() {
        this.showSuccessSnackbar('Cupo del cliente modificado exitosamente.')
      },*/
      showEmailError() {
        this.showErrorSnackbar('Error al cambiar el estado de la cobranza automatica del cliente.')
      },
      showEmailSuccess() {
        this.showSuccessSnackbar('El estado de la cobranza automatica del cliente modificado exitosamente.')
      },
      showUpdateCreditError() {
        this.showErrorSnackbar('Error al modificar cupo maximo del cliente.')
      },
      showUpdateCreditSuccess() {
        this.showSuccessSnackbar('Cupo y holgura del cliente modificado exitosamente.')
      },
      showUpdateError() {
        this.showErrorSnackbar('Error al modificar descuento y condicion de pago del cliente.')
      },
      showUpdateSuccess() {
        this.showSuccessSnackbar('Descuento y condicion de pago del cliente modificado exitosamente.')
      },
      submitBlock() {
        return this
          .toWait(true)
          .then(this.toBlock)
          .then(this.toRefresh)
          .then(this.toWait)
      },
      /*submitCredit() {
        return this
          .toWait(true)
          .then(this.toCredit)
          .then(this.toRefresh)
          .then(this.toWait)
      },*/
      submitEmail() {
        return this
          .toWait(true)
          .then(this.toEmail)
          .then(this.toRefresh)
          .then(this.toWait)
      },
      submitUpdate() {
        return this
          .toWait(true)
          .then(this.toUpdate)
          .then(this.toRefresh)
          .then(this.toWait)
      },
      submitUpdateCredit(event) {
        //
        this.selected = event.item
        //
        return this
          .toWait(true)
          .then(this.toUpdateCredit)
          .then(this.toRefresh)
          .then(this.toWait)
      },
      toBlock() {
        return SlCustomerService
          .blockUnlock()
          .attach(this.slCustomer.toBlock())
          .then(this.showBlockSuccess)
          .catch(this.showBlockError)
      },
      /*toCredit() {
        return this
          .slCustomer
          .changeMaxCustomerCredit()
          .attach(this.slCustomer.toCredit())
          .then(this.showCreditSuccess)
          .catch(this.showCreditError)
      },*/
      toEmail() {
        return this
          .slCustomer
          .toggleSendDebtEmail()
          .save()
          .then(this.showEmailSuccess)
          .catch(this.showEmailError)
      },
      toUpdate() {
        return this
          .slCustomer
          .toUpdate()
          .save()
          .then(this.showUpdateSuccess)
          .catch(this.showUpdateError)
      },
      toUpdateCredit(event) {
        //
        const slCustomerBranchOffice = new SlCustomerBranchOfficesModel(this.selected)
        //
        return slCustomerBranchOffice
          .customerCredit()
          .sync(slCustomerBranchOffice.toCustomerCredit())
          .then(this.showUpdateCreditSuccess)
          .catch(this.showUpdateCreditError)        
      },
      toRefresh() {
        return this
          .getSlCustomer()
          .then(this.setSlCustomer)
      },
      toWait(wait = false) {
        return this
          .$refs
          .form
          .setWait(wait)
      },
    },
    mounted() {
      this.toRefresh()
    },
  }
</script>
